<template>
	<div class="pxrwwfgv-drawer" :class="{'-open': $store.getters['drawerOpen']}" ref="drawer">
		<div class="pxrwwfgv-drawer-inner">
			<div class="pxrwwfgv-drawer-content">
				<div class="pxrwwfgv-drawer-top">
					<div class="pxrwwfgv-drawer-title">{{title}}</div>
					<div class="pxrwwfgv-interventions">
						<div
							class="pxrwwfgv-intervention-option"
							v-for="(intervention) in $store.getters['interventions']"
							:key="intervention.id"
							:class="{'-selected': (selectedIntervention && intervention.id === selectedIntervention.id)}"
							:style="{'background-image': 'url(' + intervention.thumbnail + ')'}"
							@click="selectIntervention(intervention.id)"
							@pointerdown="(event) => { startDrag(event, intervention) }"
						>
						</div>
					</div>
					<Transition name="int-info" mode="out-in">
						<div class="pxrwwfgv-intervention-info" :key="selectedIntervention.id" v-if="selectedIntervention">
							<div class="pxrwwfgv-intervention-title">{{selectedIntervention.title}}</div>
							<div class="pxrwwfgv-intervention-desc">{{selectedIntervention.desc}}</div>
						</div>
						<div class="pxrwwfgv-intervention-info" key="desc" v-else-if="!selectedIntervention">
							<div class="pxrwwfgv-intervention-desc">Kattints az ikonokra bővebb magyarázatért!</div>
						</div>
					</Transition>
				</div>
				<div class="pxrwwfgv-drawer-bottom">
					<div class="pxrwwfgv-drawer-go-to-home" @click="goToHome">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.3 85.03">
							<g>
								<path class="cls-1" d="M59.3,55.37c0,16.38-13.28,29.87-29.65,29.65C12.6,84.79-.17,71.69,0,55.37.17,39,29.65,0,29.65,0c0,0,29.65,39,29.65,55.37Z"/>
							</g>
						</svg>
						<wwf-icon name="home-back" :size="32" color="#009612" />
						<div class="pxrwwfgv-drawer-go-to-home-label">Vissza a főoldalra</div>
					</div>
				</div>
			</div>
			<div class="pxrwwfgv-drawer-handle">
				<svg class="pxrwwfgv-drawer-handle-shape" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.3 135.91">
					<g>
						<polygon @click="toggleDrawer" points="0,0 0,135.9 14.3,135.9 46.3,106.3 46.3,29.6 14.3,0 	"/>
					</g>
				</svg>
				<wwf-icon name="double-arrow-right" :size="27" color="#fff" @click="toggleDrawer" />
			</div>


			<HelpClickAnim left="5" top="90" v-if="idle && $store.getters['drawerOpen'] && !$store.getters['allSpotPlaced']" />
		</div>
	</div>
</template>

<script setup >
	import {ref, computed, defineProps, onMounted, watch} from 'vue';
	import _ from 'lodash';
	import {useStore} from 'vuex';
	import { useMouseInElement, useIdle } from '@vueuse/core';

	import WwfIcon from "@/components/ui/WwfIcon.vue";
	import HelpClickAnim from '@/components/ui/HelpClickAnim.vue';

	defineProps(['title']);
	const store = useStore();

	//drawer
	const drawer = ref(null);
	const { isOutside: isMouseOutsideDrawer } = useMouseInElement(drawer);

	onMounted(() => {
		setTimeout(() => {
			store.dispatch('setDrawerOpen', true);
		}, 150);
	});

	function toggleDrawer(){
		store.dispatch('setDrawerOpen', !store.getters['drawerOpen']);
	}

	function goToHome(){
		store.dispatch('setScreen', 'home');
	}

	watch(isMouseOutsideDrawer, (newIsOutside, oldIsOutside) => {
		if(newIsOutside){
			if(!oldIsOutside && store.getters['inDrag']){
				store.dispatch('setDrawerOpen', false);
			}
		}
		else {
			if(oldIsOutside && store.getters['inDrag']){
				store.dispatch('setDrawerOpen', true);
			}
		}
	});

	//interventions
	const selectedIntervention = ref(null);

	function selectIntervention(id){
		selectedIntervention.value = _.find(store.getters.interventions, (iv) => iv.id === id);
	}

	function startDrag(event, intervention){
		store.dispatch('startDrag', {
			coords: [event.clientX, event.clientY],
			intervention: intervention,
		});
	}

	const selectedDropSpot = computed(() => store.getters.selectedDropSpot);
	watch(selectedDropSpot, () => {
		if(selectedDropSpot.value){
			let spotIv = store.getters['spotPlacedIntervention'](selectedDropSpot.value.id);
			
			if(spotIv){
				selectIntervention(spotIv.intervention.id);
			}
		}
	});

	//help
	const { idle } = useIdle(1 * 60 * 1000); //1 min 1 * 60 * 1000
</script>

<style scoped>
	.pxrwwfgv-drawer {
		position: absolute;
		z-index: 2;
		--drawer-width: 400px;
		width: var(--drawer-width);
		height: 100%;
		left: calc(-1 * var(--drawer-width) + 10px);
		top: 0px;
		color: #fff;

		background-color: var(--color-light-green);
		transition: left 500ms ease-out;
	}
	.pxrwwfgv-drawer.-open {
		left: 0px;
	}
	.pxrwwfgv-drawer-inner {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-right: 10px;

		transition: padding 500ms ease-out;
	}
	.pxrwwfgv-drawer.-open .pxrwwfgv-drawer-inner {
		padding-right: 0px;
	}
	.pxrwwfgv-drawer-handle {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 46px;
		height: 136px;
		left: calc(100% - 14px);
	}
	.pxrwwfgv-drawer-handle-shape polygon {
		cursor: pointer;
		fill: var(--color-light-green);
	}
	.pxrwwfgv-drawer-handle .pxrwwfgv-icon {
		position: absolute;
		right: 8px;
		cursor: pointer;

		transform: rotate(0deg);
		transition: transform 500ms ease-out;
	}
	.pxrwwfgv-drawer.-open .pxrwwfgv-drawer-handle .pxrwwfgv-icon {
		transform: rotate(180deg);
	}
	.pxrwwfgv-drawer-content {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 25px;
		justify-content: space-between;
		align-items: stretch;
	}
	.pxrwwfgv-drawer-top {
		display: flex;
		flex-direction: column;
		gap: 25px;
		justify-content: space-between;
		align-items: stretch;
	}
	.pxrwwfgv-drawer-title {
		background-color: var(--color-dark-green);
		font-family: var(--font-heading);
		font-size: 32px;
		text-transform: uppercase;
		letter-spacing: 1px;
		text-align: center;
		padding: 15px 30px;
	}
	.pxrwwfgv-interventions {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 25px;
		flex-wrap: wrap;
		padding: 25px 0px;
	}
	.pxrwwfgv-intervention-option {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 122px;
		height: 122px;
		border-radius: 100%;

		background-size: contain;
		background-position: 50% 50%;
		background-repeat: no-repeat;
		
		cursor: pointer;
	}
	.pxrwwfgv-intervention-option::before {
		content: '';
		display: block;
		position: absolute;
		z-index: 2;
		pointer-events: none;
		width: calc(100% + 10px);
		height: calc(100% + 10px);
		border-radius: 100%;

		border: 0px solid #fff;
		opacity: 0;
		transform: scale(1.5);
		transition: all 300ms ease-out;
	}
	.pxrwwfgv-intervention-option.-selected::before {
		border-width: 10px;
		opacity: 1;
		transform: scale(1);
	}

	.pxrwwfgv-intervention-info {
		padding: 0px 35px;
	}
	.pxrwwfgv-intervention-title {
		font-family: var(--font-heading);
		font-size: 32px;
		text-transform: uppercase;
		letter-spacing: 1px;
		margin-bottom: 15px;
	}
	.pxrwwfgv-intervention-desc {
		font-size: 24px;
	}

	.int-info-enter-active,
	.int-info-leave-active {
		transition-duration: 450ms;
	}
	.int-info-enter-active .pxrwwfgv-intervention-title,
	.int-info-leave-active .pxrwwfgv-intervention-title {
		transition: all 300ms ease-out;
	}
	.int-info-enter-active .pxrwwfgv-intervention-desc,
	.int-info-leave-active .pxrwwfgv-intervention-desc {
		transition: all 300ms ease-out 150ms;
	}

	.int-info-enter-from .pxrwwfgv-intervention-title,
	.int-info-enter-from .pxrwwfgv-intervention-desc {
		opacity: 0;
		transform: translateY(50px);
	}

	.int-info-leave-to .pxrwwfgv-intervention-title,
	.int-info-leave-to .pxrwwfgv-intervention-desc {
		opacity: 0;
		transform: translateY(-50px);
	}

	.pxrwwfgv-drawer-go-to-home {
		position: relative;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 20px;
		cursor: pointer;
		padding: 35px;
	}
	.pxrwwfgv-drawer-go-to-home svg {
		display: block;
		width: 46px;
		heigh: 136px;
	}
	.pxrwwfgv-drawer-go-to-home svg path {
		fill: var(--color-light-blue);
	}
	.pxrwwfgv-drawer-go-to-home .pxrwwfgv-icon {
		position: absolute;
		left: 42px;
		bottom: 45px;
	}
	.pxrwwfgv-drawer-go-to-home-label {
		font-family: var(--font-heading);
		font-size: 18px;
		text-transform: uppercase;
		letter-spacing: 1px;
		margin-bottom: -15px;
	}
</style>